/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice } from "@reduxjs/toolkit";
import { getPurchasesAction } from "../actions/adminDashboardAction";

const initialState: any = {};

const getPurchaseSlice = createSlice({
  name: "Guest User Purchase Data",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getPurchasesAction.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(getPurchasesAction.fulfilled, (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    });

    builder.addCase(getPurchasesAction.rejected, (state) => {
      state.isLoading = false;
    });
  },
});

export default getPurchaseSlice.reducer;
